'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _List = require('../List/List');

var _List2 = _interopRequireDefault(_List);

var _FloatingButton = require('../FloatingButton/FloatingButton');

var _FloatingButton2 = _interopRequireDefault(_FloatingButton);

var _Card = require('material-ui/Card');

var _reactRouterRedux = require('react-router-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.navigateTo = _this.navigate.bind(null, context.store.dispatch, props.route);
    return _this;
  }

  _createClass(_class, [{
    key: 'getExpandableList',
    value: function getExpandableList(list, index) {
      var title = list.title,
          route = list.route,
          others = _objectWithoutProperties(list, ['title', 'route']);

      return _react2.default.createElement(
        _Card.Card,
        { key: index },
        _react2.default.createElement(_Card.CardHeader, {
          title: title,
          actAsExpander: true,
          showExpandableButton: true
        }),
        _react2.default.createElement(
          _Card.CardText,
          { expandable: true },
          _react2.default.createElement(_List2.default, others)
        )
      );
    }
  }, {
    key: 'navigate',
    value: function navigate(dispatch, route) {
      dispatch((0, _reactRouterRedux.push)(route));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.lists.map(this.getExpandableList),
        _react2.default.createElement(_FloatingButton2.default, {
          type: 'add',
          onMouseUp: this.navigateTo,
          onTouchEnd: this.navigateTo
        })
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  route: _react2.default.PropTypes.string,
  lists: _react2.default.PropTypes.array.isRequired
};
_class.contextTypes = {
  store: _react2.default.PropTypes.object.isRequired
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/ExpandableList/ExpandableList.js
 ** module id = 491
 ** module chunks = 0
 **/